import MediaQuery from 'react-responsive';
import SVG, { Props as SVGProps } from 'react-inlinesvg';
import Key6 from '../components/keys/key6';
import Key7 from '../components/keys/key7';
import Key5Mobile from '../components/keys/key5mobile';
import Key6Mobile from '../components/keys/key6mobile';
import VideoIntersection from '../components/videoIntersection';
const nittyVideo = '/ReactAssets/CustomerJourney/NITTY_MAIN.mp4';
const loadingPoster = '/ReactAssets/CustomerJourney/loading.gif';
function NittyGritty({ animate }) {
   return (
      <div className="flex nittygritty mobile-reverse-order">
         <div className="col-1/2 overflow-visible">
            <div className="center">
               <VideoIntersection 
               animate={animate} 
               poster={loadingPoster}
               src={nittyVideo} 
               loop />
            </div>
            <div className="content">
               <h2>
                  The nitty gritty of buying
                  <br />
                  your new home!!
               </h2>
               <p>
                  Whether you’re a first-time buyer or taking your next exciting
                  step up the property ladder, we’re here to help you get a grip
                  on the financial and legal side of things. Start here with our
                  handy{' '}
                  <a href="/help-and-advice/stamp-duty-calculator.aspx">
                     Stamp Duty
                  </a>{' '}
                  and{' '}
                  <a href="/help-and-advice/mortgage-calculator.aspx">
                     Mortgage Calculators
                  </a>
                  . We can put you in touch with{' '}
                  <a href="/promo/recommended-mortgage-advisers.aspx">
                     financial advisers
                  </a>{' '}
                  who could find you the best mortgage
                   and give you free guidance. And our{' '}
                  <a href="/promo/recommended-solicitors.aspx">
                     recommended solicitors
                  </a>{' '}
                  will give you independent advice and
                  make all the details easier for you to understand.
               </p>
               <a
                  href="/help-and-advice"
                  class="btn btn-primary"
                  target="_blank"
               >
                  Work out my finances
               </a>
            </div>
            <MediaQuery maxWidth={767}>
               <Key6Mobile animate={animate} />
            </MediaQuery>
            <MediaQuery minWidth={768}>
               <Key7 animate={animate} />
            </MediaQuery>
         </div>
         <div className="col-1/2">
            <MediaQuery maxWidth={767}>
               <Key5Mobile animate={animate} />
            </MediaQuery>
            <MediaQuery minWidth={768}>
               <Key6 animate={animate} />
            </MediaQuery>
         </div>
      </div>
   );
}

export default NittyGritty;
